// src/hooks/useEnhancedHealthSummary.ts

import { useState, useEffect, useRef } from 'react';
import { HealthSummary } from '../lib/health/types'; // Import the source of truth

// The hook now uses the main HealthSummary type directly
export function useEnhancedHealthSummary() {
  const [data, setData] = useState<HealthSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchInProgress = useRef(false);

  useEffect(() => {
    if (fetchInProgress.current) return;
    fetchInProgress.current = true;

    const fetchEnhancedHealthData = async () => {
      try {
        console.log('🚀 Fetching health summary...');
        
        // Create a cache-busting query parameter rounded to the nearest hour
        const now = new Date();
        now.setMinutes(0, 0, 0); // Round down to the hour
        const cacheBuster = now.getTime();

        const response = await fetch(`/data/health/health-summary.json?v=${cacheBuster}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch health summary: ${response.statusText}`);
        }

        const healthData: HealthSummary = await response.json();
        console.log('📊 Received health summary:', healthData);
        
        // No more data massaging needed. The JSON format is now the source of truth.
        setData(healthData);

      } catch (err) {
        console.error('❌ Error fetching health data:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchEnhancedHealthData().finally(() => {
      fetchInProgress.current = false;
    });
  }, []);

  return { 
    data, 
    loading, 
    error
  };
}